<script lang="ts">
  import type { LeaderboardSkillsDetailsSkillItem, SkillCategory } from '$lib/api/types';
  import SkillBtn from '../common/SkillBtn.svelte';

  interface Props {
    category: SkillCategory;
    skills: LeaderboardSkillsDetailsSkillItem[];
  }

  let { category, skills }: Props = $props();
</script>

<div class="category-item">
  <h5 class="category-header">{category.name}</h5>
  <ul class="skills small">
    {#each skills as skill (skill.skillId)}
      <SkillBtn name={skill.skillName} pointsValue={skill.pointsValue} withIcon isComplete={skill.completed} />
    {/each}
  </ul>
</div>

<style>
  .category-item {
    flex: 1;
  }
  .category-header {
    border-bottom: solid var(--bs-border-width) var(--bs-border-color);
    padding-bottom: 0.25em;
  }

  .skills {
    /* font-size: 16px; */
    margin: 0;
    padding: 0;
  }
</style>
